import { ConsentPreferenceUpdateInput } from '@main/cm-types';
import { PurposeInput } from '@main/sombra-types';

import { Purpose } from '../CommunicationsPreferences/components';

/**
 * Create input for updateDataSubjectConsentPreferences mutation
 *
 * @param identifier - the identifier of the data subject
 * @param partition - the partition to update
 * @param purposes - the selected purposes/preferences
 * @returns input for updateDataSubjectConsentPreferences mutation
 */
export function getUpdateDataSubjectConsentPreferencesInput(
  identifier: string,
  partition: string,
  purposes: Record<string, Purpose>,
): ConsentPreferenceUpdateInput {
  return {
    identifier,
    partition,
    purposes: Object.entries(purposes).map(
      ([purpose, { consent, preferences }]) => ({
        purpose,
        consent,
        ...(preferences
          ? {
              preferences: Object.entries(preferences).map(
                ([topic, choice]) => {
                  // remove __typename from choice before calling graphql
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
                  const { __typename, ...rest } = choice as any;
                  return { topic, choice: { ...rest } };
                },
              ),
            }
          : {}),
      }),
    ) as PurposeInput[],
  };
}
